import { useContext, useEffect } from 'react'
import { useParams } from 'react-router'

//
// import { useMyInfo } from 'gql/__utils__/useMyInfo'
import { fileMetaRemoveFakeFile } from 'gql/files/cache'
import type { UppyResult, UppySuccessful, UppySucssesfull, UppyType } from 'store/models'
import { removeFilesUppyFromLocalStorage } from 'utils/removeFilesUppyFromLocalStorage'

import { UppyContext } from './UppyContext'

export type OnUppyCompleteType = (
  uppy: UppyType,
  result: UppyResult,
  data: UppySuccessful[],
) => void

type OptionsType = {
  maxFileSize?: null | number
  maxNumberOfFiles?: null | number
  minNumberOfFiles?: null | number
  allowedFileTypes?: null | string[]
}

export const useUppy = (onComplete?: OnUppyCompleteType, options?: OptionsType): UppyType => {
  const { companyId, projectId } = useParams<{
    companyId: string
    projectId: string
  }>()
  // const { profile } = useMyInfo()

  const uppy = useContext(UppyContext)

  useEffect(() => {
    uppy.setOptions({
      restrictions: options,
    })
  }, [uppy, options])

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const completeCallback = async (result: any) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      result.successful.forEach((e: any) => {
        uppy.removeFile(e.id)
        removeFilesUppyFromLocalStorage(e.id)
      })

      const data: { successful: UppySucssesfull[]; id?: string }[] = [
        { successful: result.successful as UppySucssesfull[] },
      ]

      setTimeout(() => {
        onComplete?.(uppy, result, data)
      })
    }

    uppy.on('file-removed', (file) => {
      if (!file?.progress?.uploadComplete && file?.meta?.fileMetaId) {
        fileMetaRemoveFakeFile(file.meta.fileMetaId as string)
      }
    })

    uppy.on('complete', completeCallback)

    return () => {
      uppy.off('complete', completeCallback)
    }
  }, [uppy, companyId, projectId, onComplete])

  return uppy
}
